// src/components/VisionStatement.js
// src/components/VisionStatement.js
import React from 'react';

const VisionStatement = () => (
  <section className="bg-gradient-to-r from-blue-500 to-teal-500 text-white py-16 text-center">
    <h2 className="text-5xl font-extrabold mb-6 text-shadow-lg">
      Our Vision
    </h2>
    <p className="text-lg max-w-4xl mx-auto text-opacity-90">
      At Edera, our vision is to revolutionize education through technology, 
      making learning more accessible, engaging, and effective for students and educators worldwide.
    </p>
  </section>
);

export default VisionStatement;
